/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { baseActions } from "document-model";
import { documentEditorBaseOperationsActions } from "./gen/creators.js";

/** Actions for the DocumentEditor document model */

export const actions = {
  ...baseActions,
  ...documentEditorBaseOperationsActions,
};
